import { GridCellProps } from '@progress/kendo-react-grid'
import { LinkOutIcon } from 'components/icons/link-out'
import React from 'react'

export class ArticleLink extends React.Component<GridCellProps> {
    public render() {
      const url = this.props.dataItem.url ? this.props.dataItem.url : this.props.dataItem.identifier
      return (
        <td>
            {url
              ?
              <a href={url} target="_blank" rel="noopener">
                <LinkOutIcon/>
              </a>
            : null
            }
        </td>
      )
    }
  }
